import header from './header.js';
import productFormVariantSelector from './productFormVariantSelector.js';
import priceBinding from './priceBinding.js';
import cart from './cart.js';
import searchOverlay from './searchOverlay.js';
import './Plaintext.Util.js';
import './components/Spinner.js';
import './components/StyledDropdown.js';
import ageGate from './ageGate.js';
import productAvailability from './productAvailability.js';
import expander from './expander.js';
import findUs from './FindUs.js';
import orderForm from './orderForm.js';
import shopNow from './ShopNow.js';

(function() {
function init() {
  header.init();
  productFormVariantSelector.init();
  priceBinding.init();
  cart.init();
  searchOverlay.init();
  ageGate.init();
  productAvailability.init();
  expander.init();
  orderForm.init();
  findUs.init();
  shopNow.init();

  // Init styled dropdowns
  document.querySelectorAll('select.styledDropdown').forEach(e => window.Plaintext.StyledDropdown.init(e));
  document.querySelectorAll('.spinner').forEach(e => window.Plaintext.Spinner.enable(e));
  setBodyWidth();
} 
  
function setBodyWidth() {
  const fullWidth = document.body.clientWidth;
  document.documentElement.style.setProperty('--fullWidth', `${fullWidth}px`);
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', init);
}
else {
  init();
}

if (document.readyState === 'complete') {
  setBodyWidth();
}
else {
  window.addEventListener('load', setBodyWidth);
}
  
window.addEventListener('resize', setBodyWidth);

})();
